// src/components/home/SellerSection.jsx
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "../../../components/general/button/Button";
import {
  FaArrowRight,
  FaUserPlus,
  FaChartLine,
  FaMapMarkerAlt,
  FaTachometerAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/business/sellerSection/SellerSection.css";
import graph from "../../../assets/images/home/business/graph.avif";
const SellerSection = ({ showExploreButton = true }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const steps = [
    {
      icon: <FaUserPlus />,
      title: "Create Your Account",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Upload Your Documents",
    },
    {
      icon: <FaTachometerAlt />,
      title: "Launch Your Dashboard",
    },
  ];

  // Scroll animation observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isVisible) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2, rootMargin: "0px 0px -50px 0px" },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const handleExploreMore = () => {
    navigate("/business");
  };

  const handleRegister = () => {
    navigate("/role-select");
  };

  return (
    <section
      ref={sectionRef}
      className={`seller-section ${isVisible ? "is-visible" : ""}`}
    >
      <Container>
        <Row className="align-items-center g-4">
          {/* LEFT SIDE - Content */}
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <div className="seller-content">
              {/* Title */}
              <h2 className="seller-title">
                Ready to Grow Your Business
                <br /> or Start Earning
                <br />
                with KisaanMart?
              </h2>

              {/* Description */}
              <p className="seller-description">
                Our Webapp is designed with your business growth in mind, making
                it easy to attract more customers and maximize profits with
                minimal effort. Join KisaanMart as a farmer, store owner, or
                deliveryman. Sell your agricultural products, reach more
                customers, or earn by delivering orders. KisaanMart provides a
                simple platform to grow your business and create new earning
                opportunities.
              </p>

              {/* Buttons */}
              <div className="seller-buttons">
                <Button
                  variant="gradient"
                  size="large"
                  className="seller-btn-first"
                  icon={<FaArrowRight />}
                  iconPosition="right"
                  onClick={handleRegister}
                >
                  Register Now
                </Button>

                {showExploreButton && (
                  <Button
                    variant="outline"
                    size="large"
                    className="seller-btn-explore"
                    onClick={handleExploreMore}
                  >
                    Explore More
                  </Button>
                )}
              </div>

              {/* Steps Section - Horizontal Card */}
              <div className="steps-horizontal-card">
                {steps.map((step, index) => (
                  <div key={index} className="step-horizontal-item">
                    <div className="step-icon">{step.icon}</div>
                    <h5 className="step-title">{step.title}</h5>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* RIGHT SIDE - Illustration */}
          <Col xs={12} lg={6}>
            <div className="seller-illustration">
              <div className="illustration-wrapper">
                {/* Main Image */}
                <img
                  src={graph}
                  alt="Business Growth"
                  className="seller-main-image"
                />

                {/* Floating Elements */}
                <div className="floating-element element-1">
                  <FaChartLine />
                </div>
                <div className="floating-element element-2">
                  <span>📈</span>
                  <span>Growth</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Background Decorations */}
      <div className="seller-bg-decoration decoration-1"></div>
      <div className="seller-bg-decoration decoration-2"></div>
    </section>
  );
};

export default SellerSection;
